import React, { Component } from 'react';
import { utilHelper } from '../../helpers';

import TitleIcon from '@material-ui/icons/Title';

class TemplateMng extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateID: props.templateID,
            themeID: props.themeID,
            templateList: props.templateList,

            layoutThemes: "",
            layoutThemeCode: "",
            keypadThemes: "",
            keypadThemeCode: "",
            themes: "",
        };
    }
    componentDidMount() {
        if (this.state.templateList.length > 0) this.setTemplateThemes(this.state.templateID, this.state.themeID);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.templateList !== this.props.templateList ||
            prevProps.templateID !== this.props.templateID ||
            prevProps.themeID !== this.props.themeID) {
            this.setState({
                templateID: this.props.templateID,
                themeID: this.props.themeID,
                templateList: this.props.templateList
            }, () => { this.setTemplateThemes(this.props.templateID); });
        }
    }


    setTemplateThemes = (templateID) => {
        let themes = [];

        this.state.templateList.filter(template => {
            if (template.templateID === templateID) {
                themes = template.themes;
            }
            return template;
        });

        this.setState({
            themes: themes,
        }, () => { this.setThemeCodes(); });

        return themes;
    };

    // templateID, themeID에 대한 layoutThemes, keypadThemes 설정 
    setThemeCodes = () => {
        let layoutThemeCode = "";
        let keypadThemeCode = "";
        let layoutThemes = [];
        let keypadThemes = [];

        this.state.themes.map(theme => {
            if (theme.themeID === this.state.themeID) {
                layoutThemeCode = theme.layoutThemeCode;
                keypadThemeCode = theme.keypadThemeCode;
            }
            return theme;
        });

        this.state.themes.map((theme, i) => {
            if (!layoutThemes.includes(theme.layoutThemeCode)) layoutThemes.push(theme.layoutThemeCode);
            if (theme.layoutThemeCode === layoutThemeCode && !keypadThemes.includes(theme.keypadThemeCode)) keypadThemes.push(theme.keypadThemeCode);
            return theme;
        });

        this.setState({
            layoutThemes: layoutThemes,
            layoutThemeCode: layoutThemeCode,
            keypadThemes: keypadThemes,
            keypadThemeCode: keypadThemeCode,
        });
    };


    handleValueChange = (name, value) => {
        if (name === "templateID") {
            const themes = this.setTemplateThemes(parseInt(value));

            this.setState({
                templateID: parseInt(value),
                themeID: themes[0].themeID,
            }, () => { this.props.setTemplateInfoStatus("template", this.state.templateID, this.state.themeID); });
        }
        else {
            this.setState({
                layoutThemeCode: name === "layoutThemeCode" ? value : this.state.layoutThemeCode,
                keypadThemeCode: name === "keypadThemeCode" ? value : this.state.keypadThemeCode,
            }, () => { this.findThemeIDbyThemeCodes(this.state.layoutThemeCode, this.state.keypadThemeCode); });
        }
    };

    findThemeIDbyThemeCodes = (layoutThemeCode, keypadThemeCode) => {
        const selectedTheme = this.state.themes.filter(theme => theme.layoutThemeCode === layoutThemeCode).filter(theme => theme.keypadThemeCode === keypadThemeCode);
        this.setState({
            themeID: selectedTheme.length > 0 ? selectedTheme[0].themeID : this.state.themes[0].themeID
        }, () => { this.props.setTemplateInfoStatus("template", this.state.templateID, this.state.themeID); });
    };

    render() {
        const { templateID, layoutThemeCode, keypadThemeCode, templateList, layoutThemes, keypadThemes } = this.state;
        const { isMobile } = this.props;

        return (
            <>
                {/* <!-- 컨텐츠설정_템플릿설정 --> */}
                <div className="templateMng">
                    <div className="tm-z1">
                        <div className="templateMng-title">
                            {!isMobile && 
                                <img style={{width: "18px", height: "18px", marginRight: "10px"}} src="assets/images/screenMod/ic-theme.svg" alt="" />
                            }
                            <div>테마 선택</div>
                        </div>
                        <div className="templateMng-item">
                            {templateList && templateList.map((template, i) => {
                                const templateActive = template.templateID === templateID;
                                return <div key={i} className={`templateMng-item-name${templateActive ? " active" : ""}`} onClick={() => this.handleValueChange("templateID", template.templateID)}>• {template.name}</div>;
                            })}
                        </div>
                    </div>
                    <div className="tm-z1" >
                        <div className="templateMng-title">
                            {!isMobile && 
                                <img style={{width: "18px", height: "18px", marginRight: "10px"}} src="assets/images/screenMod/ic-color.svg" alt="" />
                            }
                            <div>색상 선택</div>
                        </div>
                        <div className="templateMng-item">
                            {layoutThemes && layoutThemes.map((layoutTheme, i) => {
                                const layoutActive = layoutTheme === layoutThemeCode;
                                return <div key={i} className={`templateMng-item-name${layoutActive ? " active" : ""}`} onClick={() => this.handleValueChange("layoutThemeCode", layoutTheme)}>• {utilHelper.getCodeName(layoutTheme)}</div>;
                            })}
                        </div>
                    </div>
                    <div className="tm-z1">
                        <div className="templateMng-title">
                            {!isMobile && 
                                <img style={{width: "18px", height: "18px", marginRight: "10px"}} src="assets/images/screenMod/ic-input.svg" alt="" />
                            }
                            <div>층 입력 방식</div>
                        </div>
                        <div className="templateMng-item">
                            {keypadThemes && keypadThemes.map((keypadTheme, i) => {
                                const keypadActive = keypadTheme === keypadThemeCode;
                                return <div key={i} className={`templateMng-item-name${keypadActive ? " active" : ""}`} onClick={() => this.handleValueChange("keypadThemeCode", keypadTheme)}>• {utilHelper.getCodeName(keypadTheme)}</div>;
                            })}
                        </div>
                    </div>
                </div>
                {(!templateList || templateList.length === 0) &&
                    <div className="text-align-center" style={{ margin: "auto" }} >
                        <img style={{ margin: "auto", marginTop: '90px' }} src={"/assets/images/ic-no-data.svg"} alt="데이터없음" /><br /><br />
                        데이터가 없습니다.
                    </div>
                }
            </>
        );
    }
}

export default TemplateMng;